// @flow
export { default } from './LetterLikeButton';



// WEBPACK FOOTER //
// ./src/components/letter/LetterLikeButton/index.js